export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '河南省郑州市惠济区开元路天伦庄园',
  uc_host: 'https://user.jizhongkeji.com',
  site_host: 'https://sem.jizhongkeji.com',
  special_url: '/',
  site_title: '集中科技-网络营销服务平台',
  welcome_title: '集中科技 — 网络营销服务平台！',
  site_short_title: '集中科技',
  site_subtitle: '网络营销服务平台',
  company_name: '郑州集中科技有限公司',
  copyright: '© 2023 郑州集中科技有限公司',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/231126/d9141cef530eda3d7af84fddc0a10953.png',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/231126/0127e57203f33f4c099bbe2bc8845be3.png',
  payment: '',
  qq: '2366682392',
  tel: '18838209698',
  company_account_id: '00717021100001216',
  company_bank: '郑州农村商业银行股份有限公司惠济支行',
  company_bank_name: '郑州集中科技有限公司',
  alipay_account_id: '2366682392@qq.com',
  alipay_name: '郑州集中科技有限公司',
  alipay_pic: '',
  section_id: 5331059,
  belonger_id: 5331059,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 